import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { map } from "rxjs";
import { ProfileService } from "src/app/pages/profile/profile.service";
import { StoreService } from "src/app/services/apps/store/store.service";
import { resolveInitialSetupOnboardingUrl } from "./first-time-user-experience.helper";

export const redirectToFirstTimeUserExperienceGuard: CanActivateFn = () => {
  const profileService = inject(ProfileService);
  const storeService = inject(StoreService);
  const router = inject(Router);

  const userProfile = profileService.userProfile();

  return storeService.getCachedOrLoad().pipe(
    map((stores) => {
      const initialSetupUrl = resolveInitialSetupOnboardingUrl(
        userProfile,
        stores ?? [],
      );
      if (initialSetupUrl) {
        return router.parseUrl(initialSetupUrl);
      }
      return true;
    }),
  );
};
